import PropTypes from 'prop-types';
import { useMutation } from '@apollo/client';
import { MISSED_DEPARTURE } from 'store/mutations';
import AgentPortalError from 'errors/AgentPortalError';

const MissedDepartureMutation = ({ children, onCompleted }) => {
  const [missedDeparture, state] = useMutation(MISSED_DEPARTURE, {
    onError: (err) => {
      throw new AgentPortalError(err);
    },
    onCompleted
  });

  return children(missedDeparture, state);
};

MissedDepartureMutation.propTypes = {
  children: PropTypes.func.isRequired,
  onCompleted: PropTypes.func.isRequired,
  variables: PropTypes.shape({
    bookingReference: PropTypes.string.isRequired
  })
};

export default MissedDepartureMutation;
